<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        Fill in the missing information for each of the following solutions at
        <stemble-latex content="$25^o\text{C.}$" />
      </p>

      <table style="max-width: 650px">
        <thead class="thead-dark text-center br">
          <th style="vertical-align: middle; height: 50px" />
          <th style="vertical-align: middle; height: 50px">
            <chemical-latex content="[H3O+] (M)" />
          </th>
          <th style="vertical-align: middle; height: 50px">
            <chemical-latex content="[OH-] (M)" />
          </th>
          <th style="vertical-align: middle; height: 50px">
            <stemble-latex content="$\text{pH}$" />
          </th>
          <th style="vertical-align: middle; height: 50px">
            <stemble-latex content="$\text{pOH}$" />
          </th>
        </thead>

        <tbody>
          <tr>
            <td style="height: 15px">
              <stemble-latex content="$\text{a)}$" />
            </td>
            <td>
              <number-value :value="h3oconc1" />
            </td>
            <td>
              <calculation-input
                v-model="inputs.ohconc1"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <calculation-input
                v-model="inputs.pH1"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <calculation-input
                v-model="inputs.pOH1"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
          </tr>
          <tr>
            <td style="height: 15px">
              <stemble-latex content="$\text{b)}$" />
            </td>
            <td>
              <calculation-input
                v-model="inputs.h3oconc2"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <number-value :value="ohconc2" />
            </td>
            <td>
              <calculation-input
                v-model="inputs.pH2"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <calculation-input
                v-model="inputs.pOH2"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
          </tr>
          <tr>
            <td style="height: 15px">
              <stemble-latex content="$\text{c)}$" />
            </td>
            <td>
              <calculation-input
                v-model="inputs.h3oconc3"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <calculation-input
                v-model="inputs.ohconc3"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <number-value :value="pH3" />
            </td>
            <td>
              <calculation-input
                v-model="inputs.pOH3"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
          </tr>
          <tr>
            <td style="height: 15px">
              <stemble-latex content="$\text{d)}$" />
            </td>
            <td>
              <calculation-input
                v-model="inputs.h3oconc4"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <calculation-input
                v-model="inputs.ohconc4"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <calculation-input
                v-model="inputs.pH4"
                group-size="sm"
                class="centered-input ma-1"
                :show-scientific-notation="false"
              />
            </td>
            <td>
              <number-value :value="pOH4" />
            </td>
          </tr>
        </tbody>
      </table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import NumberValue from '../NumberValue';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '../displayers/ChemicalLatex';

export default {
  name: 'Question134',
  components: {
    StembleLatex,
    CalculationInput,
    NumberValue,
    ChemicalLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        ohconc1: null,
        pH1: null,
        pOH1: null,
        h3oconc2: null,
        pH2: null,
        pOH2: null,
        h3oconc3: null,
        ohconc3: null,
        pOH3: null,
        h3oconc4: null,
        ohconc4: null,
        pH4: null,
      },
    };
  },
  computed: {
    h3oconc1() {
      return this.taskState.getValueBySymbol('h3oconc1').content;
    },
    ohconc2() {
      return this.taskState.getValueBySymbol('ohconc2').content;
    },
    pH3() {
      return this.taskState.getValueBySymbol('pH3').content;
    },
    pOH4() {
      return this.taskState.getValueBySymbol('pOH4').content;
    },
  },
};
</script>
<style scoped>
td {
  vertical-align: center;
  text-align: center;
}
</style>
